"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftJs = require("draft-js");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = require("immutable");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _throttle = _interopRequireDefault(require("transmute/throttle"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var DEFAULT_COUNT = 0;
var THROTTLE_FOR_RECALCULATING_WORD_COUNT_MS = 333;
var getWordCountByBlock = (0, _memoize.default)(function (block) {
  if (!block) {
    return DEFAULT_COUNT;
  }

  var matches = block.getText().match(/\w+/gi);
  return matches ? matches.length : DEFAULT_COUNT;
}, function (block) {
  return block.hashCode();
});

var _default = (0, _createReactClass.default)({
  displayName: "WordCount",
  propTypes: {
    editorState: _propTypes.default.instanceOf(_draftJs.EditorState).isRequired,
    noEdit: _propTypes.default.bool.isRequired,
    useLineHeight: _propTypes.default.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      noEdit: false,
      useLineHeight: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      count: DEFAULT_COUNT
    };
  },
  componentDidMount: function componentDidMount() {
    this.getWordCount = this.getDebouncedWordCount();
    this.getWordCount(this.props.editorState);
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(newProps) {
    var editorState = this.props.editorState;
    var newEditorState = newProps.editorState;

    if (newEditorState && !(0, _immutable.is)(editorState && editorState.getCurrentContent(), newEditorState.getCurrentContent())) {
      this.getWordCount(newEditorState);
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    var count = this.state.count;
    return count !== nextState.count || this.props.noEdit !== nextProps.noEdit;
  },
  _getWordCount: function _getWordCount(editorState) {
    if (editorState) {
      var blocks = editorState.getCurrentContent().getBlockMap() || [];
      var count = blocks.reduce(function (acc, block) {
        return acc + getWordCountByBlock(block);
      }, DEFAULT_COUNT);
      this.setState({
        count: count
      });
    }
  },
  getDebouncedWordCount: function getDebouncedWordCount() {
    return (0, _throttle.default)(THROTTLE_FOR_RECALCULATING_WORD_COUNT_MS, this._getWordCount);
  },
  render: function render() {
    var _this$props = this.props,
        noEdit = _this$props.noEdit,
        useLineHeight = _this$props.useLineHeight;
    var count = this.state.count;
    var style = useLineHeight ? {
      lineHeight: 1.25
    } : {};

    if (noEdit) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "composer-word-count p-right-2",
      style: style
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.composer.wordCount",
      options: {
        count: count
      }
    }));
  }
});

exports.default = _default;
module.exports = exports.default;